import { Card, CardContent, Typography, Button } from '@mui/material';
import styles from '../styles/jobAdvertCard.module.scss';
import { useNavigate, useParams } from 'react-router-dom';
export default function JobAdvertCard({ advert }) {
    const navigate = useNavigate();
    const formatDate = (dateString) => {

    if (!dateString) return '';

    const date = new Date(dateString);

    return date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });
};

    return (

        <Card className={styles.card} elevation={3}>

            <CardContent className={styles.content}>

                <Typography
                    variant="h5"
                    className={styles.title}
                >
                    {advert.jobTitle}
                </Typography>
                <div className={styles.details}>
                <Typography className={styles.detail}>
                    Location: {advert.locationName}
                </Typography>

                <Typography className={styles.detail}>
                    Salary: {advert.salary}
                </Typography>

                <Typography className={styles.detail}>
                    Closing Date: {formatDate(advert.closingDate)}
                </Typography>
                
                <Button
                    className={styles.button}
                    variant="contained"
                    fullWidth
                    onClick={() => navigate(`/job/${advert.id}`)}
                >
                    Apply
                </Button>
                </div>
            </CardContent>

        </Card>

    );

}